module.exports = __webpack_public_path__ + "static/media/3.16fec99b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/3.jpg
// module id = 1735
// module chunks = 0